
import { supabase } from "@/integrations/supabase/client";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAuth } from "@/contexts/AuthContext";
import { useToast } from "@/hooks/use-toast";
import { CreateParcelData, Parcel } from "./types";

/**
 * Hook to create a new parcel
 */
export const useCreateParcel = () => {
  const queryClient = useQueryClient();
  const { user } = useAuth();
  const { toast } = useToast();

  return useMutation({
    mutationFn: async (parcelData: CreateParcelData) => {
      if (!user) {
        throw new Error("Utilisateur non authentifié");
      }

      const { data, error } = await supabase
        .from('parcels')
        .insert({ ...parcelData, user_id: user.id })
        .select('*')
        .single();

      if (error) throw error;

      return data as Parcel;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['parcels'] });
      toast({
        title: "Parcelle créée",
        description: "Votre parcelle a été ajoutée avec succès."
      });
    },
    onError: (error: Error) => {
      toast({
        title: "Erreur",
        description: error.message || "Une erreur est survenue lors de la création de la parcelle.",
        variant: "destructive"
      });
    }
  });
};
